import { CreditCardIcon, TextAlignStartIcon, UsersIcon } from "lucide-react";

import { EntitySettingsFragment } from "@/__generated__/graphql";
import { ObjectType } from "@/objects/@types";

const object: ObjectType<EntitySettingsFragment> = {
  humanName: "entity-settings",
  typename: "EntitySettingsObject",
  ReactIcon: UsersIcon,
  getTitle: () => {
    return "Entity Settings";
  },
  getEntityId: () => {
    return null;
  },
  fieldDefinitions: [
    {
      objectKey: "id",
      label: "Name",
      type: "text",
      ReactIcon: TextAlignStartIcon,
      asString: (data) => data?.id,
      getValue: (data) => {
        return data?.id;
      },
      getValueOptions: () => ({
        placeholder: "Acme Technology Solutions LLC, etc.",
      }),
      updateProps: {
        isRequired: false,
        isEditable: true,
      },
      summaryProps: {
        isVisible: true,
      },
      fieldProps: {
        headerFieldType: "string",
      },
    },
  ],
};

export { object as EntitySettingsObject };
